export default {"src":"/_next/static/media/time.fb51f81b.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};